import React, {useCallback, useEffect, useState} from 'react'
import Axios from 'axios'
import {useParams, Link} from 'react-router-dom'
import {Row, Col} from 'reactstrap'
import ReactHtmlParser from 'react-html-parser'

import {API_URL} from '../../ApiUrl.js'
import styles from './SingleArt.module.css'

function SingleArt() {
  let {id} = useParams()
  const [art, setArt] = useState({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [type, setType] = useState('')

  const getArts = useCallback(async () => {
    try {
      setLoading(true)
      const res = await Axios.get(`${API_URL}/api/sculptures`)
      const artId = res.data.find((item) => item.id === id)
      const typeLabel = artId.Type.label
      setType(typeLabel)
      setArt(artId)
      setLoading(false)
    } catch (err) {
      setError(err)
    }
  }, [id])

  useEffect(() => {
    getArts()
  }, [getArts])

  const handleScrollToTop = () => {
    window.scrollTo(0, 0)
  }

  return (
    <div className={styles.artSinglePage}>
      {loading && <p style={{color: 'orange'}}>...Chargement...</p>}
      {error && <p style={{color: 'red'}}>Something bad happened please reload page</p>}

      {/* Back button - desktop only */}
      <Row className="d-none d-lg-block">
        <Col>
          <Link
            className={styles.backButton}
            to="."
            onClick={handleScrollToTop}
            relative="path"
          >
            &#8592; Retour
          </Link>
        </Col>
      </Row>

      {/* Title section */}
      <Row className={styles.artSinglePageTitles}>
        <Col xs="12" className={styles.colH4}>
          <h4 className="type">{type}</h4>
        </Col>
        <Col xs="12" className={styles.colH3}>
          <h3 className="title-art">{art.title}</h3>
        </Col>
      </Row>

      {/* Image + description */}
      <Row className={`align-items-center ${styles.contentRow}`}>
        <Col xs="12" md="12" lg="7" className={styles.imageDiv}>
          <img src={art.imageUrl} alt={art.title} className="img-fluid" />
        </Col>

        <Col xs="12" md="12" lg="4" className="offset-md-1 mt-3 mt-md-0">
          <div className="box">
            <div className="text-single-art col-flex">
              {ReactHtmlParser(art.description)}
              <p className={`margin-0 ${styles.price}`}><u>Prix</u>: {art.price} €</p>
            </div>
            {art.command && (
              <div className="text-single-art mt-3">
                <b>&laquo; {art.command} &raquo;</b>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SingleArt
